import clsx from "clsx";
import getPlayerContent from "@/domains/chat/helpers/getPlayerContent";
import type { MessageProps } from "@/domains/chat/helpers/messageProps";
import Time from "@/domains/chat/components/chat/messages/parts/Time";
import { TypePaintingMessage } from "@/domains/settings/chat/constants/chat";

export default function ChatSpeakMessage({ message, settings }: MessageProps) {
  const { showTime, messageHeader, typePaintingMessage } = settings;

  return (
    <div className={clsx("overflow-clip w-full text-[#e0ffff]")}>
      <div className={clsx(messageHeader ? "" : "inline")}>
        {showTime && <Time date={message.date} />} <span>{getPlayerContent(message)}</span>
        {": "}
      </div>
      <div
        className={clsx("font-medium", {
          "text-white": typePaintingMessage !== TypePaintingMessage.Classic,
          inline: !messageHeader,
        })}
      >
        {message.message.content}
      </div>
    </div>
  );
}
